// extracted by mini-css-extract-plugin
export default {"table":"view_table__7AlTG"};